export const getName = state => state.name

export const getTelephone = state => state.telephone

export const getFax = state => state.fax

export const getEmail = state => state.email

export const getDepartment = state => state.department

export const isDepartment = (code) => state => {
  return state.departmentCode === code
}

export const getAccountAssignedId = state => state.accountAssignedId

export const apificate = state => {
  return {
    name: state.name,
    phone: state.telephone,
    fax: state.fax,
    email: state.email,
    department: state.department,
    departmentCode: state.departmentCode,
    accountAssignedId: state.accountAssignedId
  }
}

export const hasData = state => {
  return Object.values(state).reduce((acc, x) => {
    return !!x || acc
  }, false)
}
